import redirectUri from "./redirect.config";
import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
    authority: process.env.REACT_APP_MSAL_AUTHORITY,
    knownAuthorities: ["login.microsoftonline.com"],
    redirectUri: redirectUri,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: ["User.Read", "User.Read.All"],
};

export const OsTicket = process.env.REACT_APP_OS_TICKET;

export const whatsappServices = {
  waendpoint: process.env.REACT_APP_WA_ENDPOINT,
  api_key: {
    "x-api-key": process.env.REACT_APP_WA_API_KEY,
  },
  it_service_group: process.env.REACT_APP_WA_IT_SERVICE_GROUP,
};

export const graphConfig = {
  graphMeEndpoint: process.env.REACT_APP_GRAPH_ME_ENDPOINT,
};

export const farms_backend = {
  endpoint: process.env.REACT_APP_FARMS_BACKEND_ENDPOINT,
  api_key: process.env.REACT_APP_FARMS_BACKEND_API_KEY,
};

export const fuel_service = {
  endpoint: process.env.REACT_APP_FUEL_ENDPOINT,
};

export const booking_driver = {
  endpoint: process.env.REACT_APP_BOOKING_DRIVER_ENDPOINT,
};

export const capex_service_endpoint = {
  endpoint: process.env.REACT_APP_CAPEX_ENDPOINT,
};

export const approval_service_endpoint = {
  endpoint: process.env.REACT_APP_APPROVAL_ENDPOINT,
};

export const travel_service_endpoint = {
  endpoint: process.env.REACT_APP_TRAVEL_ENDPOINT,
  api_key: process.env.REACT_APP_FARMS_BACKEND_API_KEY,
};

export const ppe_service_endpoint = {
  endpoint: process.env.REACT_APP_PPE_ENDPOINT,
};

export const sap_service_endpoint = {
  endpoint: process.env.REACT_APP_SAP_ENDPOINT,
}

export const hets_service_endpoint = {
  endpoint: process.env.REACT_APP_HETS_ENDPOINT,
}

export const sap_endpoint = {
  endpoint: process.env.REACT_APP_SAP_ENDPOINT,
};

export const master_v2_service_endpoint = {
  endpoint: process.env.REACT_APP_MASTER_V2_ENDPOINT,
}

export const wellness_endpoint = {
  endpoint: process.env.REACT_APP_WELLNESS_ENDPOINT
}

export const bidding_endpoint = {
  endpoint: process.env.REACT_APP_BIDDING_ENDPOINT,
};

export const epicor_service_endpoint = {
  endpoint: process.env.REACT_APP_EPICOR,
};

export const service_request_endpoint = {
  endpoint: process.env.REACT_APP_SERVICE_REQUEST_ENDPOINT,
};

export const dastr_endpoint = {
  endpoint: process.env.REACT_APP_DASTR_ENDPOINT,
};

export const pa_service_endpoint = {
  endpoint: process.env.REACT_APP_PA_ENDPOINT,
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL instance once
msalInstance.initialize();
